<template>
  <div>
        <FormulateInput
            v-model="formValues"
            class="mt-3"
            label="Student Information"
            name="studentInfo"
            type="group"

        >
            <b-row class="student-info-form">
                <b-col md="4">
                    <FormulateInput 
                    name="studentId" 
                    type="text"
                    placeholder="Student ID" 
                    validation-name="Student ID"
                    />
                </b-col>
                <b-col md="4" v-if="showStudentIdConfirm()">
                    <FormulateInput 
                    name="studentId_confirm" 
                    type="text"
                    placeholder="Please Confirm Your Student ID" 
                    validation-name="Student ID confirmation"
                    validation="required|confirm"
                    />
                </b-col>                
              </b-row>
            <b-row class="student-info-form">
                <b-col md="4">
                    <FormulateInput 
                    name="firstName" 
                    type="text"
                    placeholder="First Name"
                    validation-name="Name"
                    :validation="[
                        ['^required'],
                        ['specialChar']
                    ]"
                    :validation-rules="{
                        specialChar
                    }"
                    :validation-messages="{
                        specialChar:`Please type in a valid name.`,
                    }"
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput 
                    name="middleName" 
                    type="text"
                    placeholder="Middle Name" 
                    validation-name="Middle Name" 
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput 
                    name="lastName" 
                    type="text"
                    placeholder="Last Name" 
                    validation-name="Name"
                    :validation="[
                        ['^required'],
                        ['specialChar']
                    ]"
                    :validation-rules="{
                        specialChar
                    }"
                    :validation-messages="{
                        specialChar:`Please type in a valid name.`,
                    }"
                    />
                </b-col>            
                <b-col md="4">
                    <FormulateInput 
                        name="DOB" 
                        type="date"
                        placeholder="Date of Birth" 
                        validation-name="Date of birth"
                        :validation="[
                            ['^required'],
                            ['afterToday']
                        ]"
                        :max="today()"
                        :validation-rules="{
                            afterToday: ({ value }) => new Date(value) < new Date()
                        }"
                        :validation-messages="{
                            afterToday:`Birthday should before today`,
                        }"
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput
                    name="gender" 
                    type="select"
                    placeholder="Select your gender" 
                    validation="^required"
                    :options="genderList"
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput 
                    name="language" 
                    type="vue-select"
                    placeholder="Select your language" 
                    validation="^required"
                    :options="languageList"
                    value="en"
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput 
                    name="grade" 
                    type="vue-select"
                    placeholder="Select your grade" 
                    validation="^required"
                    :options="gradeList"
                    />
                </b-col>
                <b-col md="4">
                    <v-select
                        type="vue-select"
                        v-model="selectedProgramType"
                        :options="programList"
                        label="description"
                        :reduce="program => program.id"
                        placeholder="Select your Program Type">
                    </v-select>
                    <FormulateInput
                        type="hidden"
                        name="program"
                        v-model="selectedProgramType"
                        validation="^required"
                    />
                </b-col>
                <b-col md="4" v-if="selectedProgramType == 11">
                    <FormulateInput
                    v-if="selectedProgramType == 11"
                    name="marssCode" 
                    type="text"
                    placeholder="MARSS Code"
                    validation="^required"
                    />
                </b-col>
                <b-col md="4">
                    <FormulateInput
                    v-if="selectedProgramType == 1"
                    name="customProgram"
                    type="text"
                    placeholder="Write your program type here"
                    validation="^required"
                    />
                </b-col>
            </b-row>
            </FormulateInput>
    </div>
</template>

<script>
import { getProgram } from '../services/api.js';
import DropdownLists from '../components/DropdownLists.json';

    export default {
        name: "StudentInfo",
        components: {},
        props: {
            defaultValue: [],
        },
        data() {
            return {
                formValues: {},
                selectedProgramType: "",
                genderList: DropdownLists.genderList,
                languageList: DropdownLists.languageList,
                gradeList: DropdownLists.gradeList,
                programList: [],
            }
        },
        methods: {
          showStudentIdConfirm() {
            return this.formValues?.[0]?.studentId !== this.defaultValue?.[0]?.studentId
          },
            specialChar ({ value }) {
                var format = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
                return !format.test(value)

            },
            onSubmit(event) {
                event.preventDefault()
                alert(JSON.stringify(this.form))
            },
            handle () {
                this.$emit('input', this.formValues)
                alert('studentInfo Validated.')
            },
            today() {
                var date = new Date();
                var month = date.getMonth() + Number(1);
                if (month < 10) {
                    month = '0'+month;
                }
                return date.getFullYear() +'-'+ month +'-'+ date.getDate()
            },
            setDefault() {
                if (this.defaultValue) {
                    this.selectedProgramType = this.defaultValue[0].program
                    this.formValues = this.defaultValue
                }
            },
        },
        mounted() {
            getProgram()
                .then(result => result.data)
                .then(result => {
                    this.programList = result
                }, error => {
                    console.error(error);
                });
            this.setDefault();
        }
    }
    // https://stackoverflow.com/questions/47311936/v-model-and-child-components
</script>
<style>
    .student-info-form div .formulate-input {
        margin-bottom: 7px;
    }
</style>